import React, {Component} from 'react'
import './MusicAlgoNav.css'
import {Navbar, Nav, MenuItem} from 'react-bootstrap'

class MusicAlgoNav extends Component {
    render() {
        return (
            <Navbar collapseOnSelect style={{paddingBottom:"0", marginBottom:"0"}}>
                <Navbar.Header>
                  <Navbar.Brand>
                    <a href="/"> 
                      <img className="logoNavbar" src="./noteSq3.png" alt="MusicAlgo" />
                    </a>
                  </Navbar.Brand>
                  <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                  <Nav>
                    <MenuItem eventkey={1} href="/binary-search">Binary Search</MenuItem>
                    <MenuItem eventkey={2} href="/selection-sort">Selection Sort</MenuItem>
                    <MenuItem eventkey={3} href="/bubble-sort">Bubble Sort</MenuItem>
                    <MenuItem eventkey={3} href="/insertion-sort">Insertion Sort</MenuItem>
                    <MenuItem eventkey={4} href="/prerequisites">Prerequisites</MenuItem>
            {/*<MenuItem eventkey={5} href="/feedback">Feedback</MenuItem>*/}
                  </Nav>
                </Navbar.Collapse>
            </Navbar>
        )
    }
}
export default MusicAlgoNav


// WEBPACK FOOTER //
// ./src/MusicAlgoNav/MusicAlgoNav.js